export class AttendingFilter {
  public attendingId;
  public customerName;
  public branchName;
  public autoEletricName;
  public currentStep;
  public scheduleDate;
  public status;
  public monitoringUser;
  public jiraTicket;
  public vehiclePlate;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/filter/attending-filter.ts